import { Delta } from "@vueup/vue-quill";

export const useCreateInlineEditingAnnotation = async (
  documentId: string,
  paragraphId?: string,
  isEndLine: boolean = false,
  lastTokenGlobalPosition?: number,
  isStartLine: boolean = false,
  isBeforeParagraph: boolean = false
) => {
  const { createDefaultAnnotation, setAnnotationBeingInlineEdited } =
    useAnnotationFormState();

  const { saveAnnotation } = useSaveAnnotation(documentId);

  var annotation = createDefaultAnnotation();

  annotation.forceAfterToken = true;
  annotation.forceInline = true;
  annotation.commentObject = new Delta().insert("").ops;
  annotation.isEndLine = isEndLine;
  annotation.isStartLine = isStartLine;
  annotation.isBeforeParagraph = isBeforeParagraph;

  if (paragraphId) {
    annotation.paragraphId = paragraphId;
  }

  if (lastTokenGlobalPosition) {
    annotation.lastTokenGlobalPosition = lastTokenGlobalPosition;
  }

  await saveAnnotation(annotation, false, true);

  setAnnotationBeingInlineEdited(documentId, annotation);
};
